<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'债权融资管理'},{name:'融资租赁公司列表'}]" :title="'融资租赁公司列表'"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">账号状态</span>
                        <el-select v-model="sendInfoOne.status" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">分类</span>
                        <el-select v-model="sendInfoOne.classify" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusLists"
                            :key="item.id"
                            :label="item.dictName"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button  size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                @sort-change="sortChange"
                 ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="recommendValue"
                    show-overflow-tooltip
                    >
                </el-table-column>
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="公司ID">
                </el-table-column>
                <el-table-column
                    prop="companyName"
                    show-overflow-tooltip
                    
                    label="公司名称">
                </el-table-column>
                <el-table-column
                    prop="classifyValue"
                    show-overflow-tooltip
                    
                    label="分类">
                </el-table-column>
                <el-table-column
                    prop="applyNum"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="申请数">
                </el-table-column>
                <el-table-column
                    prop="userName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="views"
                    show-overflow-tooltip
                    
                    label="浏览数">
                </el-table-column>
                <el-table-column
                    prop="statusValue"
                    show-overflow-tooltip
                    
                    label="账号状态">
                </el-table-column>
                <el-table-column
                    v-if="authorities.indexOf('sys:permission:background:lease:finance:company:list:button:view') != -1 || authorities.indexOf('sys:permission:background:lease:finance:company:list:button:status') != -1"
                    label="操作"
                    
                    width="200">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain v-if="authorities.indexOf('sys:permission:background:lease:finance:company:list:button:view') != -1" @click="check(scope.row)">查看</el-button>
						<el-button size="small" type="primary" class="super" plain v-if="authorities.indexOf('sys:permission:background:lease:finance:company:list:button:status') != -1" @click="soldOut(scope.row)">{{scope.row.recommendBtn}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        // breadcrumb
    },
    data(){
        return{
            loading:false,
            bHeight:void 0,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
            options: [{
                value: '2',
                label: '公司名称'
                }, {
                value: '3',
                label: '账号'
            }],//检索下拉
            getSelect:'',
            getValue:'',
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                id:null,//申请id
                userName:null,//账号
                classify:null,
				        status:null,//状态
                companyName:null,//公司名称
                property:null,//排序字段
                direction:null,//排序方式
            },//检索提交数据
            totalSize:null,
            tableData:[{name:'ads'}],//表格数据
            currentPage:1,//当前页
            statusList:[],
            scopeList:[],
			statusLists:[],//分类
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    methods:{
      onReset(){
        const params={
                currentPage:1,//当前页
                pageSize:10,//页条数
                id:null,//申请id
                userName:null,//账号
                classify:null,
				        status:null,//状态
                companyName:null,//公司名称
                property:null,//排序字段
                direction:null,//排序方式
        }
        this.sendInfoOne = Object.assign(this.sendInfoOne,params)
        this.getSelect = void 0
        this.getValue  = void 0
        this.getList()
      },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        //查询
        retrieval:function(){},
        //表格排序
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='asc';
            }else{
                order='desc';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            this.getData();
        },
        //表格查看按钮
        check:function(row){
            this.$router.push({path:'/debtManagement/companyDetail',query:{id:row.id,index:'/debtManagement/companyList'}})
        },
        getList(id,recommendBtn){
            this.$axiosz.put('backstage/financial/leasing/recommend/'+id).then(res=>{
                if(res.code == 200){
                    this.$message({
                        type: 'success',
                        message:recommendBtn+'成功!'
                    });
					this.getData()
                }
            })
        },
        //表格取推,推荐按钮
        soldOut:function(row){
            let recommendBtn=row.recommendBtn;
            this.$confirm(`确认${recommendBtn}？`, recommendBtn, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.getList(row.id , recommendBtn)
                }).catch(() => {    
            });
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        getDic(){
            this.$axiosz.get('backstage/sysDict/isShow/STATUS').then((r)=>{ //审核结果
                if(r.code==200){
                    this.statusList=r.data;
                }
            })
			// 分类
			this.$axiosz.get('/rpc/sysDict/parentId/1069409808416768').then(res=>{
			    if(res.code==200){
					this.statusLists=res.data
			    }else{
			        this.$alert(res.msg)
			    }
			})
        },
        getData(){
            this.loading = true
            this.sendInfoOne.id = ''
            this.sendInfoOne.companyName = ''
            this.sendInfoOne.userName = ''
            if(this.getSelect=='1'){ //申请id
                this.sendInfoOne.id=this.getValue;
            }else if(this.getSelect=='2'){ //公司名称
                this.sendInfoOne.companyName=this.getValue;
            }else if(this.getSelect=='3'){ //账号
                this.sendInfoOne.userName=this.getValue;
            }
            this.$axiosz.get('backstage/financial/leasing/list',{params:this.sendInfoOne}).then(res=>{
                this.loading = false
                if(res.code==200&&res.data){
                    this.tableData=res.data.content
                    this.totalSize=res.data.totalElements;
                }
            }).catch(e=>{
              this.loading = false
            })
        }
    },
    mounted(){
        const that = this
        that.getDic();
        that.getData();
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>